import { Dialogs, TokenReplacement } from 'dspx-core';

export const APPLICATION = {
  title: 'Victorian Concessions and Allowances',
  logo: '/assets/images/dffh-logo-white.png',
};

export const APPLICATION_TYPE = {
  victorianPatientTransportAssistanceScheme: 'b9d2d2b1-8997-4402-a7ca-29eecd51bb6a',
  victorianPatientTransportAdjustmentAssistanceScheme: '1d6b9425-c750-4e1c-8480-f41ba956a4af'
}

export const CONCESSIONS_APPLICATION_TYPE_CODES = {
  nonMainsWater: 'NMWC',
  nonMainsEnergy: 'NMEC',
  nonMainsLifeSupport: 'NMLSC',
  nonMainsMedicalCooling: 'NMMCC',
  edapowGoldCardMunicipalRates: 'EDAPOW'
}

export const CONCESSIONS_APPLICATION_INVOICE_TYPE = {
  nonMainsWater: 'nonMainsWater',
  nonMainsElectricity: 'nonMainsElectricity',
  generatorFuel: 'generatorFuel',
  heatingOil: 'heatingOil',
  firewood: 'firewood',
  nonMainsGas: 'nonMainsGas'
}

export const CONCESSIONS_APPLICATION_CARD_TYPE_ID = {
  DepartmentOfVeteransAffairs: 1,
  Centrelink: 2
}

export const APP_DATA_KEYS = {
  maxGridRowCount: 'maxGridRowCount',
  previousModel: 'previousModel',
  maxBulkOperationItemCount: 'maxBulkOperationItemCount',
};

export const OVERVIEW_CARDSET_LAYOUT_FIELD_TYPE_REPLACEMENTS: TokenReplacement[] = [
  { old: 'tabs', new: 'card-set-tabs-flat' },
  { old: 'page', new: 'card-set-page' },
  { old: 'page-repeating', new: 'card-set-page-repeating' },
  { old: 'page-info', new: 'card-set-page-info' },
  { old: 'page-list', new: 'card-set-page-list' },
  { old: 'page-overview', new: 'card-set-page-overview' },
  { old: 'section', new: 'card-section-overview' },
  { old: 'section-repeating', new: 'card-section-repeating' },
  { old: 'section-overview', new: 'card-section-overview' }
];

export const FORM_ACTIONS = {
  userListForm: {
    new: 'new',
    view: 'view',
    edit: 'edit',
  },
  userForm: {
    custom: 'custom',
  },
  referenceDataListForm: {
    new: 'new',
    view: 'view',
    edit: 'edit',
    custom: 'custom',
  },
  organisationListForm: {
    new: 'new',
    view: 'view',
    edit: 'edit',
  },
  applicationListForm: {
    view: 'view',
    edit: 'edit',
  },
  concessionsApplicationListForm: {
    view: 'view',
    edit: 'edit',
  },
  concessionsApplicationDetailForm: {
    view: 'view',
    edit: 'edit',
  },
  ruleListForm: {
    view: 'view',
    edit: 'edit',
  },
  personListForm: {
    view: 'view',
    edit: 'edit',
  },
  vendorListForm: {
    view: 'view',
    edit: 'edit',
  }
};

export const FORM_CUSTOM_ACTIONS = {
  referenceDataListForm: {
    bulkUpload: 'bulkUpload',
  },
};

export const POP_UP_CODES = {
  common: {
    clientError: Dialogs.CLIENT_ERROR,
    serverError: Dialogs.SERVER_ERROR,
    validationError: Dialogs.VALIDATION,
    saveSuccessful: 'saveSuccessful',
    submitSuccessful: 'submitSuccessful',
    submitIneligible: 'submitIneligible',
    confirmDocumentDeletion: 'confirmDocumentDeletion',
    vdaCardDeceasedCheck: 'vdaCardDeceasedCheck',
    vdaCardNameCheck: 'vdaCardNameCheck',
    vdaAddressPostcodeCheck: 'vdaAddressPostcodeCheck',
    centrelinkCardCheck: 'centrelinkCardCheck',
    centrelinkCardMatch: 'centrelinkCardMatch'
  },
  userForm: {
    activationSuccessful: 'activationSuccessful',
    deactivationSuccessful: 'deactivationSuccessful',
    confirmActivation: 'confirmActivation',
    confirmDeactivation: 'confirmDeactivation'
  },
  personDetail: {
    linkingCodeConfirm: 'linkingCodeConfirm',
    linkingCodeSuccessful: 'linkingCodeSuccessful',
    linkingCodeError: 'linkingCodeError',
    createPlacement: 'createPlacement',
    createVptasSource: 'createVptasSource',
    noCarerRole: 'noCarerRole',
    noOracleVendor: 'noOracleVendor',
    noClientRole: 'noClientRole',
    checkCrisRecordPresent: 'checkCrisRecordPresent',
  },
  personList: {
    updateCreateCarerApplication: 'updateCreateCarerApplication',
    updateCreatePlacementApplicationLinkClient: 'updateCreatePlacementApplicationLinkClient',
    updateCreatePlacementApplicationLinkNonClient: 'updateCreatePlacementApplicationLinkNonClient',
    noCarerRole: 'noCarerRole',
    noOracleVendor: 'noOracleVendor',
    noClientRole: 'noClientRole',
    contactMatch: 'contactMatch',
  },
  settingList: {
    confirmBulkUpdateClientInactiveDate: 'confirmBulkUpdateClientInactiveDate',
    clientInactiveDateBulkUpdateCompleted: 'clientInactiveDateBulkUpdateCompleted',
    confirmBulkUpdatePlacementEndDate: 'confirmBulkUpdatePlacementEndDate',
    placementEndDateBulkUpdateCompleted: 'placementEndDateBulkUpdateCompleted'
  },
  applicationDetailCreateUpdateCarer: {
    assignApplicationUser: 'assignApplicationUserPopup',
    acceptCreateApplicationConfirmation: 'acceptCreateApplicationConfirmation',
    acceptUpdateApplicationConfirmation: 'acceptUpdateApplicationConfirmation',
    postApplicationAcceptEmailRemainder: 'postApplicationAcceptEmailRemainderPopup',
    rejectApplicationConfirmationPopup: 'rejectApplicationConfirmationPopup',
    updateContactOnlyConfirmationPopup: 'updateContactOnlyConfirmationPopup',
    rejectApplication: 'rejectApplicationPopup',
    requestBankDetailsEmailNotSent: 'requestBankDetailsEmailNotSent'
  },
  applicationDetailCreateUpdatePlacement: {
    assignApplicationUser: 'assignApplicationUserPopup',
    confirmCreateClient: 'confirmCreateClientPopup',
    rejectApplication: 'rejectApplicationPopup',
  },
  careAllowanceYear: {
    invoicePeriodsGenerated: 'invoicePeriodsGenerated',
  },
  careAllowanceFinancialYear: {
    saveFinancialYearSuccessful: 'saveFinancialYearSuccessful',
  },
  careAllowanceCalendarYear: {
    saveCalendarYearSuccessful: 'saveCalendarYearSuccessful'
  },
  careAllowanceRateList: {
    confirmDeleteRequest: 'confirmDeleteRequest',
    confirmApprovalRequest: 'confirmApprovalRequest',
    confirmCancelPendingChanges: 'confirmCancelPendingChanges'
  },
  careAllowancePlacement: {
    holdPlacement: 'holdPlacementPopup',
    releasePlacementHold: 'releasePlacementHoldPopup',
    ceasePlacement: 'ceasePlacement',
    ceasePlacementConfirmation: 'ceasePlacementConfirmation',
  },
  careAllowancePlacementInvoiceList: {
    cancelInvoice: 'cancelInvoice',
    confirmCancelInvoice: 'confirmCancelInvoice',
    invalidDateRange: 'invalidDateRange',
  },
  careAllowancePlacementAdjustmentList: {
    invoices: 'invoices',
    overpaymentRecoverySchedule: 'overpaymentRecoverySchedule',
    adjustmentLines: 'adjustmentLines',
    cancelAdjustment: 'cancelAdjustment',
    confirmCancelAdjustment: 'confirmCancelAdjustment'
  },
  careAllowancePlacementAdjustment: {
    greaterThanConfiguredAmount: 'greaterThanConfiguredAmount',
    lessThanConfiguredAmount: 'lessThanConfiguredAmount',
    editAdjustmentLineAmount: 'editAdjustmentLineAmount',
    startDateLessThanAMonthInPast: 'startDateLessThanAMonthInPast',
    endDateGreaterThanAMonthInFuture: 'endDateGreaterThanAMonthInFuture',
    confirmSaveAdjustment: 'confirmSaveAdjustment',
  },
  iccmsRequestProcessingScheduleList: {
    confirmDelete: 'confirmDelete'
  },
  vendorForm: {
    confirmVendorSiteDelete: 'confirmVendorSiteDelete'
  },
  concessionsApplicationList: {
    deleteApplicationConfirmation: 'deleteApplicationConfirmation'
  },
  concessionsApplicationDetails: {
    assignApplicationUser: 'assignApplicationUserPopup',
    putApplicationOnHoldPopup: 'putApplicationOnHoldPopup',
    furtherReviewRequiredPopup: 'furtherReviewRequiredPopup',
    rejectApplication: 'rejectApplicationPopup',
    addCentrelinkVerifiedAddressPopup: 'addCentrelinkVerifiedAddressPopup'
  },
  concessionsApplicationNonMainsWaterForm: {
    confirmValidation: 'confirmValidation',
    invoiceDateValidation: 'invoiceDateValidation',
    checkSupportingDocValidation: 'checkSupportingDocValidation',
    duplicateInvoice: 'duplicateInvoice',
    minimumThreshold: 'minimumThreshold',
    nextTierThreshold: 'nextTierThreshold'
  },
  concessionsApplicationNonMainsEnergyForm: {
    ratesValidation: 'ratesValidation',
    invoiceDateValidation: 'invoiceDateValidation',
    confirmValidation: 'confirmValidation',
    checkSupportingDocValidation: 'checkSupportingDocValidation',
    duplicateInvoice: 'duplicateInvoice',
    minimumThreshold: 'minimumThreshold',
    nextTierThreshold: 'nextTierThreshold'
  },
  concessionsApplicationNonMainsMedicalCoolingForm: {
    confirmValidation: 'confirmValidation',
    checkSupportingDocValidation: 'checkSupportingDocValidation',
    invoiceDateValidation: 'invoiceDateValidation',
    duplicateInvoice: 'duplicateInvoice'
  },
  concessionsApplicationNonMainsLifeSupportForm: {
    confirmValidation: 'confirmValidation',
    machineDetailsValidation: 'machineDetailsValidation',
    invoiceDateValidation: 'invoiceDateValidation',
    checkSupportingDocValidation: 'checkSupportingDocValidation',
    applicationAlreadyCreated: 'applicationAlreadyCreated',
    duplicateInvoice: 'duplicateInvoice'
  },
  concessionsApplicationEdapowGoldCardMunicipalRatesForm: {
    edapowPaymentReceived: 'edapowPaymentReceived',
    edapowValidation: 'edapowValidation',
    edaDetailsNotChanged: 'edaDetailsNotChanged',
    confirmValidation: 'confirmValidation',
    invalidCard: 'invalidCard',
    ineligibleCard: 'ineligibleCard'
  },
  concessionsApplicationRebateCalculationRuleListForm: {
    confirmApprovalRequest: 'confirmApprovalRequest',
    confirmCancelPendingChanges: 'confirmCancelPendingChanges'
  },
  concessionsApplicationCommon: {
    submitSuccessful: 'submitSuccessful',
    deleteInvoice: 'deleteInvoice',
    applicationInProgress: 'applicationInProgress',
    invalidResidentialAddress: 'invalidResidentialAddress',
    maxRebateReached: 'maxRebateReached',
    invoiceHelpText: 'invoiceHelpText',
    vdaCardCheck: 'vdaCardCheck',
    centrelinkCardCheck: 'centrelinkCardCheck',
    veteransAffairsAddressCheck: 'veteransAffairsAddressCheck',
    veteransAffairsCardMatch: 'veteransAffairsCardMatch',
    centrelinkAddressCheck: 'centrelinkAddressCheck',
    centrelinkCardMatch: 'centrelinkCardMatch',
    deleteNotAuthorised: 'deleteNotAuthorised',
    cardDetailsVerification: 'cardDetailsVerification'
  },
  jobScheduler: {
    confirmRunRequest: 'confirmRunRequest',
    confirmDelete: 'confirmDelete'
  },
  exportedInvoice: {
    saveConfirmation: 'saveConfirmation',
    resubmitConfirmation: 'resubmitConfirmation'
  },
  bankDetail:
  {
    outstandingAcceptedCrateVendorApplication: 'outstandingAcceptedCrateVendorApplication',
    manuallyCreatedVendor: 'manuallyCreatedVendor',
    noBankDetailsCreateUpdateAllowed: 'noBankDetailsCreateUpdateAllowed',
    updateBankDetails: 'updateBankDetails',
    noFinancialInstitutionProviderPaymentConfirmation: 'noFinancialInstitutionProviderPaymentConfirmation'
  },
  concessionsApplicationBulkUpload: {
    saveBulkUpload: [
      'idMatchServiceUnavailable',
      'fileAlreadyProcessed',
      'invalidFileTemplateFormat',
      'partialMatchesFound',
      'allValidContacts'
    ]
  },
  careAllowancePlacementBulkAdHocInvoiceQuery: {
    confirmGenerateInvoices: 'confirmGenerateInvoices',
    confirmReRunErroredInvoices: 'confirmReRunErroredInvoices',
    confirmRunQuery: 'confirmRunQuery',
    confirmApprove: 'confirmApprove',
    confirmDelete: 'confirmDelete',
    placements: 'placements',
  },
  localAdoption: {
    createPlacement: 'createPlacement',
    inactiveContact: 'inactiveContact',
    contactNotAVendor: 'contactNotAVendor',
    placementAttributeCombination: 'placementAttributeCombination',
    sameCarerSameClientOverlappingPlacement: 'sameCarerSameClientOverlappingPlacement',
    sameClientDifferentCarerOverlappingPlacement: 'sameClientDifferentCarerOverlappingPlacement',
    noClient: 'noClient',
    noCarer: 'noCarer'
  },
  jobRunLog: {
    confirmKillJob: 'confirmKillJob',
    invoices: 'invoices',
    errors: 'errors',
    information: 'information',
  },
  careAllowancePerson: {
    confirmCarerSave: 'confirmCarerSave',
    confirmClientSave: 'confirmClientSave',
    confirmVptasClientSave: 'confirmVptasClientSave',
    confirmCarerOrConcessionEdit: 'confirmCarerOrConcessionEdit',
    confirmClientEdit: 'confirmClientEdit',
    confirmVptasClientEdit: 'confirmVptasClientEdit'
  },
  victorianPatientTransportAssistanceSchemeRateForm: {
    confirmApprovalRequest: 'confirmApprovalRequest',
    confirmCancelPendingChanges: 'confirmCancelPendingChanges'
  },
   victorianPatientTransportAssistanceScheme: {
     blockTreatmentRemoveWarning: 'blockTreatmentRemoveWarning',
     multipleModesRemoveWarning: 'multipleModesRemoveWarning',
     userUpdateCarerPlacementWarning: 'userUpdateCarerPlacementWarning',
     deleteNominatedPatientNotification: 'deleteNominatedPatientNotification',
     confirmDistanceEligibility: 'confirmDistanceEligibility',
     transportDetailsTripClone: 'transportDetailsTripClone',
     travelDatewithinTreamentDateRangeWarning: 'travelDatewithinTreamentDateRangeWarning',
     checkInwithinTreamentDateRangeWarning: 'checkInwithinTreamentDateRangeWarning',
     withinDatePeriodCheckWarning: 'withinDatePeriodCheckWarning',
  },
  vptasApplicationList: {
    bulkApproveConfirmation: 'bulkApproveConfirmation',
    deleteApplicationConfirmation: 'deleteApplicationConfirmation'
  },
  vptasApplicationDetails: {
    assignApplicationUserPopup: 'assignApplicationUserPopup',
    reAssignApplicationUserPopup: 'reAssignApplicationUserPopup',
    bulkAssignApplicationUserPopup: 'bulkAssignApplicationUserPopup',
    putApplicationOnHoldPopup: 'putApplicationOnHoldPopup',
    furtherReviewRequiredPopup: 'furtherReviewRequiredPopup',
    ineligibleApplicationPopup: 'ineligibleApplicationPopup',
    inProgressPopup: 'inProgressPopup',
    partialPaymentPopup: 'partialPaymentPopup',
    revertPartialPayment: 'revertPartialPayment',
    invalidDocumentPopup: 'invalidDocumentPopup',
    updatePatientContributionPopup: 'updatePatientContributionPopup'
  },
  vptasApplicationSubsidyList: {
    addAdjustment: 'addAdjustment',
    addAdjustmentDecimalWarning:'addAdjustmentDecimalWarning',
    createSubsidyRewindWarning: 'createSubsidyRewindWarning'
  },
  vptasInvoiceList: {
    cancelInvoice: 'cancelInvoice',
    confirmCancelInvoice: 'confirmCancelInvoice',
    invalidDateRange: 'invalidDateRange',
  },
  vptasNominatedPatientDetails: 
  {
    AddressNotInVictoria: 'addressNotInVictoria',
    selfNomination: 'selfNomination'
  },
  vptasSpecialist:{
        
  },
  vptasAdjustmentApplication: {
    validationErrorProviderDetails: 'validationErrorProviderDetails',
    validationErrorAmountZero: 'validationErrorAmountZero'
  }
};

export const POP_UP_TEXTS = {
  common: {
    confirmDocumentDeletion: '<p>Confirm the deletion of this document?</p>',
    saveInvoice: 'Please save your uploaded invoices before clicking \'Next\''
  }
};

export const POP_UP_HEADER = {
  common: {
    saveInvoice: 'Save invoice'
  }
};

export const POP_UP_STYLE_CLASS = {
  dialogXl: 'dialog-xl'
};

export const SERVER_ERROR_POP_UP_CODES = {
  saveReferenceData: [
    'duplicateCategoryCode',
    'duplicateCategoryValue',
    'duplicateCode',
    'duplicateValue',
    'duplicateDisplayOrder',
    'deletedValues',
  ],
  glStringMappingOverlapCheck: [
    'confirmOverlappingMapping'
  ],
  saveGlStringMapping: [],
  saveGlStringLookupMappingSet: [],
  saveGlStringLookupMapping: [],
  saveUser: [],
  saveOrganisation: [],
  saveCareAllowancePlacementRule: [],
  saveCareAllowanceFinancialYear: [
    'invalidFinancialYearStartDate',
    'financialYearStartDateNotWednesday',
    'financialYearEndDateNotTuesday',
    'invalidFinancialYearEndDate'
  ],
  saveCareAllowanceCalendarYear: [
    'invalidCalendarYearStartDate1',
    'invalidCalendarYearStartDate2',
    'invalidCalendarYearEndDate'
  ],
  saveCareAllowanceInvoicePeriod: [
    'invalidProcessCutOffDateTime'
  ],
  saveCareAllowancePlacementAdjustment: [
    'greaterThanEndDate',
    'startDateGreaterThanClientInactiveDate',
    'startDateGreaterThanPlacementDate',
    'startDateLessThanAMonthInPast',
    'lessThanStartDate',
    'endDateGreaterThanClientInactiveDate',
    'endDateGreaterThanPlacementDate',
    'endDateGreaterThanAMonthInFuture',
    'lineAmountTotalNotEqualToAdjustmentAmount'
  ],
  saveCareAllowanceRate: [],
  careAllowanceRateDeletionRequest: [
    'deletionRequestFailed',
    'deletionRequestFailedPendingChanges'
  ],
  careAllowanceRateApproveRequest: [
    'approvalFailed'
  ],
  careAllowanceRateCancelPendingChanges: [
    'cancelFailed'
  ],
  saveIccmsRequestProcessingSchedule: [],
  concessionsApplicationApproveRebateCalculationRuleRequest: [
    'approvalFailed'
  ],
  concessionsApplicationRebateRuleCancelPendingChanges: [
    'cancelFailed'
  ],
  saveVendor: [],
  saveConcessionsApplication: ['distanceCalculateServiceError'],
  saveConcessionsRebateCalculationRules: [],
  linkPersonToCreatePlacementApplication: [
    'personAlreadyLinkedToCreatePlacementApplication'
  ],
  saveJobSchedule: [
    'invalidStartDate',
    'invalidStartEndDateRange'
  ],
  deleteJobSchedule: [],
  deleteIccmsRequestProcessingSchedule: [],
  bulkUpdateClientInactiveDate: [
    'clientInactiveDateBulkUpdateCompletedWithErrors'
  ],
  bulkUpdatePlacementEndDate: [
    'placementEndDateBulkUpdateCompletedWithErrors'
  ]
};

export const NAV_TAB_NUMBERS = {
  dashboardCommon: {
    grid: 1,
  },
  referenceDataForm: {
    refDataCategory: 2,
    refDataValue: 3,
  },
  glStringMappingForm: {
    glStringMapping: 2
  },
  glStringLookupMappingSetForm: {
    glStringLookupMappingSet: 2
  },
  glStringLookupMappingForm: {
    glStringLookupMapping: 2
  },
  userListForm: {
    users: 1,
  },
  userForm: {
    userProfile: 2,
    applicationAccess: 3,
    accessRequests: 4,
  },
  careAllowanceApplicationListForm: {
    applications: 1
  },
  careAllowancePlacementListForm: {
    placements: 1
  },
  concessionsApplicationListForm: {
    applications: 1
  },
  concessionsApplicationNonMainsWaterForm: {
    intro: 1,
    applicant: 2,
    concessionsCard: 3,
    invoice: 4
  },
  concessionsApplicationNonMainsEnergyForm: {
    intro: 1,
    applicant: 2,
    concessionsCard: 3,
    ratesUpload: 4,
    invoice: 5
  },
  concessionsApplicationNonMainsMedicalCoolingForm: {
    intro: 1,
    applicant: 2,
    concessionsCard: 3,
    patientDetails: 4,
    invoice: 5
  },
  concessionsApplicationNonMainsLifeSupportForm: {
    intro: 1,
    applicant: 2,
    concessionsCard: 3,
    patientDetails: 4,
    invoice: 5
  },
  concessionsApplicationEdapowGoldCardMunicipalRatesForm: {
    intro: 1,
    applicant: 2,
    concessionsCard: 3,
    ratesUpload: 4
  },
  concessionsApplicationRebateCalculationRuleListForm: {
    rebateCalculationRules: 1
  },
  concessionsRebateCalculationRuleForm: {
    ruleDetails: 2
  },
  careAllowancePlacementRuleListForm: {
    placementRules: 1
  },
  careAllowanceYearForm: {
    year: 2
  },
  careAllowanceRateListForm: {
    rates: 1
  },
  careAllowanceRateForm: {
    rateDetails: 2
  },
  careAllowancePlacementInvoiceListForm: {
    invoices: 1
  },
  careAllowancePlacementAdjustmentForm: {
    adjustmentDetails: 2
  },
  personListForm: {
    persons: 1
  },
  vendorListForm: {
    vendors: 1
  },
  errorLogListForm:
  {
    errorLogs: 1
  },
  monitorInvoiceExportListForm:
  {
    monitorInvoiceExports: 1
  },
  concessionsInvoiceListForm: {
    invoices: 1
  },
  concessionsApplicationBulkUploadErrorLogForm: {
    errorLogs: 1
  },
  concessionsApplicationBulkUploadListForm: {
    bulkUploads: 1
  },
  jobScheduleForm: {
    jobSchedule: 2
  },
  jobRunLogListForm: {
    jobs: 1
  },
  bulkAdHocInvoiceQueryGridFilter: {
    bulkAdHocInvoiceQuery: 1
  },
  careAllowancePerson: {
    personDetails: 2
  },
  victorianPatientTransportAssistanceSchemeRateForm: {
    ruleDetails: 2
  },
  victorianPatientTransportAssistanceSchemeRateListForm: {
    rebateCalculationRules: 1
  },
  victorianPatientTransportAssistanceSchemeApplicationListForm: {
    applications: 1
  },
    vptasApplication: {
     preAppQuestionnaire: 1,
    applicant: 2,
    travelAndAccommodation: 3
  },
  vptasInvoiceListForm: {
    invoices: 1
  },
  vptasNominatedPatientDetailsForm: 
  {
    nominatedPatientDetails: 2,
  },
  vptasSpecialistListForm: {
    specialists: 1
  },
  vptasLgaListForm: {
    lgaList: 1
  }
};

export const PAGE_INDEX = {
  noRepeater: -1
};

export const PAGE_NUMBERS = {
  dashboardCommon: {
    grid: 1,
  },
  referenceDataForm: {
    refDataCategory: 1,
    refDataValue: 1,
  },
  glStringMappingForm: {
    glStringMapping: 1
  },
  glStringLookupMappingSetForm: {
    glStringLookupMappingSet: 1
  },
  glStringLookupMappingForm: {
    glStringLookupMapping: 1
  },
  userListForm: {
    users: 1,
  },
  userForm: {
    profile: 1,
    applicationAccess: 1,
    accessRequests: 1,
  },
  careAllowanceApplicationListForm: {
    applications: 1
  },
  careAllowancePlacementListForm: {
    placements: 1
  },
  concessionsApplicationListForm: {
    applications: 1
  },
  concessionsApplicationNonMainsWaterForm: {
    intro: 1,
    applicant: 1,
    concessionsCard: 1,
    invoice: 1
  },
  concessionsApplicationNonMainsEnergyForm: {
    intro: 1,
    applicant: 1,
    concessionsCard: 1,
    ratesUpload: 1,
    invoice: 1
  },
  concessionsApplicationNonMainsMedicalCoolingForm: {
    intro: 1,
    applicant: 1,
    concessionsCard: 1,
    patientDetails: 1,
    invoice: 1
  },
  concessionsApplicationNonMainsLifeSupportForm: {
    intro: 1,
    applicant: 1,
    concessionsCard: 1,
    patientDetails: 1,
    invoice: 1
  },
  concessionsApplicationEdapowGoldCardMunicipalRatesForm: {
    intro: 1,
    applicant: 1,
    concessionsCard: 1,
    ratesUpload: 1
  },
  concessionsApplicationRebateCalculationRuleListForm: {
    rebateCalculationRules: 1
  },
  concessionsRebateCalculationRuleForm: {
    ruleDetails: 1
  },
  careAllowancePlacementRuleListForm: {
    placementRules: 1
  },
  careAllowanceYearForm: {
    year: 1
  },
  careAllowanceRateListForm: {
    rates: 1
  },
  careAllowanceRateForm: {
    rateDetails: 1
  },
  careAllowancePlacementInvoiceListForm: {
    invoices: 1
  },
  careAllowancePlacementAdjustmentForm: {
    adjustmentDetails: 1
  },
  personListForm: {
    persons: 1
  },
  vendorListForm: {
    vendors: 1
  },
  errorLogListForm:
  {
    errorLogs: 1
  },
  monitorInvoiceExportListForm:
  {
    monitorInvoiceExports: 1
  },
  concessionsInvoiceListForm: {
    invoices: 1
  },
  concessionsApplicationBulkUploadErrorLogForm: {
    errorLogs: 1
  },
  concessionsApplicationBulkUploadListForm: {
    bulkUploads: 1
  },
  jobScheduleForm: {
    jobSchedule: 1
  },
  jobRunLogListForm: {
    jobs: 1
  },
  bulkAdHocInvoiceQueryGridFilter: {
    bulkAdHocInvoiceQuery: 1
  },
  careAllowancePerson: {
    personDetails: 1
  },
  victorianPatientTransportAssistanceSchemeRateForm: {
    ruleDetails: 1
  },
  victorianPatientTransportAssistanceSchemeRateListForm: {
    rebateCalculationRules: 1
  },
  victorianPatientTransportAssistanceSchemeApplicationListForm: {
    applications: 1
  },
 vptasApplicationForm: {
    preAppQuestionnaire: 1,
    applicantProfile: 1,
    travelAndAccommodation: 1,
    transportDetails: 1
  },
  vptasInvoiceListForm: {
    invoices: 1
  },
  vptasNominatedPatientDetailsForm: {
    nominatedPatientDetails: 1
  },
  vptasSpecialistListForm: {
    specialists: 1
  },
  vptasLgaListForm: {
    lgaList: 1
  }
};

export const SECTION_INDEX = {
  noRepeater: -1
};

export const SECTION_CODES = {
  victorianPatientTransportAssistanceSchemeApplicationListForm: {
    applications: 'application'
  },
  vptasInvoiceListForm: {
    invoiceSection: 'invoiceSection'
  },
  referenceDataForm: {
    viewRefDataCategory: 'viewRefDataCategory',
    refDataCategory: 'refDataCategory',
    refDataValue: 'refDataValue',
  },
  glStringMappingForm: {
    mappingSection: 'mappingSection'
  },
  glStringLookupMappingSetForm: {
    lookupMappingSetSection: 'lookupMappingSetSection'
  },
  glStringLookupMappingForm: {
    lookupMappingSection: 'lookupMappingSection'
  },
  userListForm: {
    user: 'user',
  },
  userForm: {
    viewUserProfile: 'viewUserProfile',
    userProfile: 'userProfile',
    applicationRef: 'applicationRef',
    accessRequests: 'accessRequests',
  },
  careAllowanceApplicationListForm: {
    application: 'application'
  },
  careAllowancePlacementListForm: {
    placementSection: 'placementSection'
  },
  concessionsApplicationListForm: {
    application: 'application'
  },
  concessionsApplicationCommon: {
    intro: 'intro'
  },
  concessionsApplicationNonMainsWaterForm: {
    invoiceInfo: 'invoiceInfo',
    cardDetails: 'cardDetails'
  },
  concessionsApplicationNonMainsEnergyForm: {
    cardDetails: 'cardDetails'
  },
  concessionsApplicationNonMainsLifeSupportForm: {
    cardDetails: 'cardDetails'
  },
  concessionsApplicationNonMainsMedicalCoolingForm: {
    cardDetails: 'cardDetails'
  },
  concessionsApplicationEdapowGoldCardMunicipalRatesForm: {
    cardDetails: 'cardDetails'
  },
  concessionsApplicationRebateCalculationRuleListForm: {
    rebateCalculationRules: 'rebateCalculationRuleSection'
  },
  concessionsRebateCalculationRuleForm: {
    rateDetails: 'ruleDetailsSection'
  },
  careAllowancePlacementRuleListForm: {
    placementRules: 'placementRules'
  },
  careAllowanceYearForm: {
    yearDetails: 'yearDetails'
  },
  careAllowanceRateListForm: {
    rates: 'rates'
  },
  careAllowanceRateForm: {
    rateDetails: 'rateDetailsSection'
  },
  careAllowancePlacementInvoiceListForm: {
    invoiceSection: 'invoiceSection'
  },
  careAllowancePlacementAdjustmentForm: {
    adjustmentDetails: 'adjustmentDetailsSection'
  },
  personListForm: {
    person: 'person'
  },
  vendorListForm: {
    vendor: 'vendor'
  },
  errorLogListForm: {
    errorLog: "errorLog"
  },
  monitorInvoiceExportListForm: {
    monitorInvoiceExport: "monitorInvoiceExport"
  },
  concessionsInvoiceListForm: {
    invoiceSection: 'invoiceSection'
  },
  concessionsApplicationBulkUploadErrorLogForm: {
    errorLog: "errorLog"
  },
  concessionsApplicationBulkUploadListForm: {
    bulkUploads: "bulkUploads"
  },
  jobScheduleForm: {
    jobSchedule: 'jobScheduleSection'
  },
  jobRunLogListForm: {
    jobsGridSection: 'jobsGridSection'
  },
  bulkAdHocInvoiceQueryGridFilter: {
    bulkAdHocInvoiceQuerySection: 'bulkAdHocInvoiceQuerySection'
  },
  careAllowancePerson: {
    profile: 'profile',
  },
  victorianPatientTransportAssistanceSchemeRateForm: {
    rateDetails: 'ruleDetailsSection'
  },
  victorianPatientTransportAssistanceSchemeRateListForm: {
    rebateCalculationRules: 'rebateCalculationRuleSection'
  },
  vptasApplicationForm: {
    preAppQuestionnaire: 'preAppQuestionnaire',
    profile: "profile",
    profileCardDetails: 'profileCardDetails',
    address: 'address',
    bankDetails: 'bankDetails',
    cardDetails: 'cardDetails',
    approvedSpecialistService: "approvedSpecialistService",
    transportDetails: 'transportDetails',
    accommodationDetails: 'accommodationDetails',
    transportDetailsTripType: 'transportDetailsTripType',
    transportDetailsIsReturnOnSameDay: 'transportDetailsIsReturnOnSameDay',
    transportDetailsDateOfReturn: 'transportDetailsDateOfReturn',
    transportDetailsTransportType: 'transportDetailsTransportType',
    transportDetailsCarTravelSubCategory: 'transportDetailsCarTravelSubCategory',
    transportDetailsTravelMode: 'transportDetailsTravelMode',
    transportDetailsTypeOfTravel: 'transportDetailsTypeOfTravel',
    transportDetailsTypeOfPublicTravel: 'transportDetailsTypeOfPublicTravel',
    transportDetailsMultipleModes: 'transportDetailsMultipleModes',
    transportDetailsDateOfTravel: 'transportDetailsDateOfTravel'
    
  },
  vptasSpecialistListForm: {
    specialists: 'specialistsSection'
  },
  vptasLgaListForm: {
    lgaList: 'vptasLgaListSection'
  },
};

export const QUESTION_CODES = {  
  victorianPatientTransportAssistanceSchemeApplicationListForm: {
    applicationListFilter: 'applicationListFilter',
    applicationPlaceholder: 'applicationPlaceholder'
  },
  vptasInvoiceListForm: {
    invoiceSearchGridFilter: 'invoiceSearchGridFilter',
    invoiceGridFilter: 'invoiceGridFilter'
  },
   nonMainsMedicalCoolingForm: {
    centrelinkCardNumber: 'centrelinkCardNumber',
    veteransAffairsCardNumber: 'veteransAffairsCardNumber',
    invoiceDocument: 'invoiceDocument',
    invoiceAmount: 'invoiceAmount',
    entitlementLetter: 'entitlementLetter',
    primaryAddress: 'primaryAddress',
    primaryAddressManualAddress: 'primaryAddress-manualAddress',
    primaryAddressStreetNumberName: 'primaryAddress-streetNumberName',
    primaryAddressSuburb: 'primaryAddress-suburb',
    primaryAddressState: 'primaryAddress-state',
    postalAddress: 'postalAddress',
    postalAddressManualAddress: 'postalAddress-manualAddress',
    patientUploadDocument: 'patientUploadDocument',
    statDecDocument: 'statDecDocument',
    patientResidentialAddress: 'patientResidentialAddress',
    patientResidentialAddressStreetNumberName: 'patientResidentialAddress-streetNumberName',
    patientResidentialAddressSuburb: 'patientResidentialAddress-suburb',
    patientResidentialAddressState: 'patientResidentialAddress-state',
  },
  referenceDataListForm: {
    referenceDataPlaceholder: 'referenceDataPlaceholder',
  },
  referenceDataForm: {
    referenceCategoryCode: 'categoryCode',
    referenceCategoryText: 'categoryText',
    referenceCategoryIsActive: 'categoryStatus',
  },
  glStringMappingForm: {
    transactionTypeId: 'transactionTypeId',
    entityValueTypeId: 'entityValueTypeId',
    costCentreValueTypeId: 'costCentreValueTypeId',
    activityValueTypeId: 'activityValueTypeId',
    fundValueTypeId: 'fundValueTypeId',
    accountValueTypeId: 'accountValueTypeId',
    productTypeValueTypeId: 'productTypeValueTypeId',
    identifierValueTypeId: 'identifierValueTypeId',
    startDate: 'startDate',
    endDate: 'endDate'
  },
  glStringLookupMappingSetForm: {
    defaultReturnValueTypeId: 'defaultReturnValueTypeId'
  },
  glStringLookupMappingForm: {
    referenceData1Id: 'referenceData1Id',
    startDate: 'startDate',
    endDate: 'endDate'
  },
  userListForm: {
    userPlaceholder: 'userPlaceholder',
    userListFilter: 'userListFilter'
  },
  userForm: {
    userEmail: 'userEmail',
    userFamilyName: 'userFamilyName',
    userGivenName: 'userGivenName',
    userPhoneWork: 'userPhoneWork',
    userOrganisation: 'userOrganisation',
    accessRequestGrid: 'accessRequestGrid',
    userType: 'userType',
    userActive: 'userActive'
  },
  organisationListForm: {
    organisationPlaceholder: 'organisationPlaceholder',
  },
  careAllowanceApplicationListForm: {
    applicationQuickSearchTerm: 'applicationQuickSearchTerm',
    applicationListFilter: 'applicationListFilter',
    applicationPlaceholder: 'applicationPlaceholder'
  },
  careAllowancePlacementListForm: {
    placementListFilter: 'placementListFilter'
  },
  concessionsApplicationListForm: {
    applicationQuickSearchTerm: 'applicationQuickSearchTerm',
    applicationListFilter: 'applicationListFilter',
    applicationPlaceholder: 'applicationPlaceholder'
  },
  concessionsApplicationDetailForm: {
    noteListPlaceholder: 'noteListPlaceholder',
    personGrid: 'personGrid'
  },
  careAllowanceYearForm: {
    startDate: 'startDate',
    endDate: 'endDate'
  },
  concessionsApplicationCommon: {
    applyForYear: 'applyForYear'
  },
  concessionsApplicationNonMainsWaterForm: {
    invoiceDocument: 'invoiceDocument',
    invoiceAmount: 'invoiceAmount',
    entitlementLetter: 'entitlementLetter',
    signedApplication: 'signedApplication',
    patientUploadDocument: 'patientUploadDocument',
    statDecDocument: 'statDecDocument',
    primaryAddress: 'primaryAddress',
    primaryAddressManualAddress: 'primaryAddress-manualAddress',
    centrelinkCardNumber: 'centrelinkCardNumber',
    veteransAffairsCardNumber: 'veteransAffairsCardNumber'
  },
  concessionsApplicationNonMainsEnergyForm: {
    entitlementLetter: 'entitlementLetter',
    signedApplication: 'signedApplication',
    ratesuploadDocument: 'ratesuploadDocument',
    centrelinkCardNumber: 'centrelinkCardNumber',
    veteransAffairsCardNumber: 'veteransAffairsCardNumber',

    invoiceNumberElectricity: 'invoiceNumberElectricity',
    invoiceAmountElectricity: 'invoiceAmountElectricity',
    invoiceDocumentElectricity: 'invoiceDocumentElectricity',
    statDecDocumentElectricity: 'statDecDocumentElectricity',

    invoiceNumberGas: 'invoiceNumberGas',
    invoiceAmountGas: 'invoiceAmountGas',
    invoiceDocumentGas: 'invoiceDocumentGas',
    statDecDocumentGas: 'statDecDocumentGas',

    invoiceNumberOil: 'invoiceNumberOil',
    invoiceAmountOil: 'invoiceAmountOil',
    invoiceDocumentOil: 'invoiceDocumentOil',
    statDecDocumentOil: 'statDecDocumentOil',

    invoiceNumberFirewood: 'invoiceNumberFirewood',
    invoiceAmountFirewood: 'invoiceAmountFirewood',
    invoiceDocumentFirewood: 'invoiceDocumentFirewood',
    statDecDocumentFirewood: 'statDecDocumentFirewood',

    invoiceNumberFuel: 'invoiceNumberFuel',
    invoiceAmountFuel: 'invoiceAmountFuel',
    invoiceDocumentFuel: 'invoiceDocumentFuel',
    statDecDocumentFuel: 'statDecDocumentFuel',

    primaryAddress: 'primaryAddress',
    primaryAddressManualAddress: 'primaryAddress-manualAddress',
  },
  concessionsApplicationNonMainsMedicalCoolingForm: {
    invoiceDocument: 'invoiceDocument',
    invoiceAmount: 'invoiceAmount',
    entitlementLetter: 'entitlementLetter',
    signedApplication: 'signedApplication',
    primaryAddress: 'primaryAddress',
    primaryAddressManualAddress: 'primaryAddress-manualAddress',
    primaryAddressStreetNumberName: 'primaryAddress-streetNumberName',
    primaryAddressSuburb: 'primaryAddress-suburb',
    primaryAddressState: 'primaryAddress-state',
    patientUploadDocument: 'patientUploadDocument',
    statDecDocument: 'statDecDocument',
    patientResidentialAddress: 'patientResidentialAddress',
    patientResidentialAddressStreetNumberName: 'patientResidentialAddress-streetNumberName',
    patientResidentialAddressSuburb: 'patientResidentialAddress-suburb',
    patientResidentialAddressState: 'patientResidentialAddress-state',
    centrelinkCardNumber: 'centrelinkCardNumber',
    veteransAffairsCardNumber: 'veteransAffairsCardNumber'
  },
  concessionsApplicationNonMainsLifeSupportForm: {
    entitlementLetter: 'entitlementLetter',
    signedApplication: 'signedApplication',
    primaryAddress: 'primaryAddress',
    primaryAddressManualAddress: 'primaryAddress-manualAddress',
    primaryAddressStreetNumberName: 'primaryAddress-streetNumberName',
    primaryAddressSuburb: 'primaryAddress-suburb',
    primaryAddressState: 'primaryAddress-state',
    patientUploadDocument: 'patientUploadDocument',
    patientResidentialAddress: 'patientResidentialAddress',
    patientResidentialAddressStreetNumberName: 'patientResidentialAddress-streetNumberName',
    patientResidentialAddressSuburb: 'patientResidentialAddress-suburb',
    patientResidentialAddressState: 'patientResidentialAddress-state',
    centrelinkCardNumber: 'centrelinkCardNumber',
    veteransAffairsCardNumber: 'veteransAffairsCardNumber',

    invoiceNumber: 'invoiceNumber',
    invoiceDocument: 'invoiceDocument',
    statDecDocument: 'statDecDocument',
    invoiceAmount: 'invoiceAmount',

    invoiceNumberWater: 'invoiceNumberWater',
    invoiceDocumentWater: 'invoiceDocumentWater',
    statDecDocumentWater: 'statDecDocumentWater',
    invoiceAmountWater: 'invoiceAmountWater',
  },
  concessionsApplicationEdaAndPowGoldCardMunicipalRatesForm: {
    invoiceDocument: 'invoiceDocument',
    entitlementLetter: 'entitlementLetter',
    signedApplication: 'signedApplication',
    ratesuploadDocument: 'ratesuploadDocument',
    primaryAddress: 'primaryAddress',
    primaryAddressManualAddress: 'primaryAddress-manualAddress',
    edapowCardNumber: 'edapowCardNumber'
  },
  concessionsApplicationRebateCalculationRuleListForm: {
    rebateCalculationRuleListFilter: 'rebateCalculationRuleListFilter'
  },
  concessionsRebateCalculationRuleForm: {
    applicationType: 'applicationType'
  },
  careAllowanceRateForm: {
    rateType: 'rateType'
  },
  paymentRuleListForm: {
    ruleGrid: 'ruleGrid'
  },
  careAllowancePlacementRuleListForm: {
    placementRuleListFilter: 'placementRuleListFilter'
  },
  careAllowanceRateListForm: {
    rateListFilter: 'rateListFilter'
  },
  careAllowancePlacementInvoiceListForm: {
    invoiceGridFilter: 'invoiceGridFilter',
    invoiceSearchGridFilter: 'invoiceSearchGridFilter',
  },
  careAllowancePlacementAdjustmentForm: {
    adjustmentTransactionType: "adjustmentTransactionType",
    adjustmentStartDate: "adjustmentStartDate",
    adjustmentEndDate: "adjustmentEndDate",
    adjustmentNumberOfFortnights: "adjustmentNumberOfFortnights",
    immediateAdjustmentAmount: "immediateAdjustmentAmount",
    adjustmentFortnightDebitAmount: "adjustmentFortnightDebitAmount",
    adjustmentFortnightCreditAmount: "adjustmentFortnightCreditAmount",
    adjustmentTotalRecoveryAmount: "adjustmentTotalRecoveryAmount",
    adjustmentComments: "adjustmentComments",
    adjustmentDocuments: "adjustmentDocuments",
    adjustmentLineDetailsGrid: "adjustmentLineDetailsGrid",
    adjustmentLineDetailsGridColumns: {
      amount: "amount",
      runningBalance: "runningBalance",
    }
  },
  personListForm: {
    personListFilter: 'personListFilter',
    personGrid: 'personGrid'
  },
  vendorListForm: {
    vendorListFilter: 'vendorListFilter',
    vendorGrid: 'vendorGrid'
  },
  vendorForm: {
    vendorSiteGrid: 'vendorSiteGrid'
  },
  errorLogListForm:
  {
    errorLogSearchTerm: 'errorLogSearchTerm',
    errorLogListFilter: "errorLogListFilter"
  },
  concessionsApplicationDetailsForm: {
    applicationDocumentPlaceholder: 'applicationDocumentPlaceholder',
    previousApplicationsGrid: 'previousApplicationsGrid'
  },
  vptasApplicationDetailsForm: {
    applicationDocumentPlaceholder: 'applicationDocumentPlaceholder',
    previousApplicationsGrid: 'previousApplicationsGrid',
    personGrid: 'personGrid'
  },
  vptasApplicationSubsidyForm:{
      subsidy:'subsidy'
  },
  monitorInvoiceExportListForm: {
    monitorInvoiceExportListFilter: 'monitorInvoiceExportListFilter'
  },
  concessionsInvoiceListForm: {
    invoiceListFilter: 'invoiceListFilter',
    invoiceGrid: 'invoiceGrid'
  },
  concessionsApplicationBulkUploadErrorLogForm: {
    errorLogListFilter: "errorLogListFilter"
  },
  concessionsApplicationBulkUploadForm: {
    fileName: 'fileName'
  },
  concessionsApplicationBulkUploadListForm: {
    bulkUploadListFilter: 'bulkUploadListFilter'
  },
  jobScheduleForm: {
    jobType: 'jobType',
    scheduleType: 'scheduleType',
    recurringFrequency: 'recurringFrequency'
  },
  jobRunLogListForm: {
    jobsGridFilter: 'jobsGridFilter'
  },
  careAllowancePlacementBulkAdHocInvoiceQueryListForm: {
    bulkAdHocInvoiceQueryGridFilter: 'bulkAdHocInvoiceQueryGridFilter'
  },
  careAllowancePerson: {
    contactType: 'contactType',
    multiContactType: 'multiContactType',
    showContactType: 'showContactType',
    showMultiContactType: 'showMultiContactType',
    isEditing: 'isEditing',
  },
  victorianPatientTransportAssistanceSchemeRateListForm: {
    rebateCalculationRuleListFilter: 'rebateCalculationRuleListFilter'
  },
  vptasApplicationForm: {
    preAppQuestionnaireMultiCheckbox: 'preAppQuestionnaireMultiCheckbox',
     selectPatient: 'selectPatient',
     centrelinkCardNumber: 'centrelinkCardNumber',
     veteransAffairsCardNumber: 'veteransAffairsCardNumber',
     isBlockTreatment: 'isBlockTreatment',
     claimTypes: 'claimTypes',
     treatmentLocation: 'approvedSpecialistServiceTreatmentLocation',
     isMultipleModes: 'isMultipleModes',
     tripDetailsErrorMessage: 'tripDetailsErrorMessage',
     transportDocumentDateOfTravel: 'transportDocumentDateOfTravel',
     transportDocument: 'transportDocument',
     transportDetailsStartLocation: 'transportDetailsStartLocation',
     transportDetailsStartLocationManualAddress: 'transportDetailsStartLocation-manualAddress',
     transportDetailsEndLocation: 'transportDetailsEndLocation',
     treatmentStartDate: 'treatmentStartDate',
     treatmentDates: 'treatmentDates',
     treatmentEndDate: 'treatmentEndDate',
     dischargeDate: 'dischargeDate',
     transportDetailsDocuments: 'transportDetailsDocuments',
     transportDetailsTransportType: 'transportDetailsTransportType',
     transportDetailsTypeOfTravel: 'transportDetailsTypeOfTravel',    
     accommodationDetailsDocuments: 'accommodationDetailsDocuments',
     numberOfNightsApprovedBySpecialist: 'numberOfNightsApprovedBySpecialist',
     approvedSpecialistServiceTreatmentLocationManualAddress: 'approvedSpecialistServiceTreatmentLocation-manualAddress',
     approvedSpecialistServiceTreatmentLocation: 'approvedSpecialistServiceTreatmentLocation',
     approvedSpecialistServiceTreatmentLocationAutoStreetNumberName: 'approvedSpecialistServiceTreatmentLocation-autoStreetNumberName',
     approvedSpecialistServiceTreatmentLocationAutoSuburb: 'approvedSpecialistServiceTreatmentLocation-autoSuburb',
     approvedSpecialistServiceTreatmentLocationAutoState: 'approvedSpecialistServiceTreatmentLocation-autoState',
     approvedSpecialistServiceTreatmentLocationAutoPostCode: 'approvedSpecialistServiceTreatmentLocation-autoPostCode',
     approvedSpecialistServiceTreatmentLocationStreetNumberName: 'approvedSpecialistServiceTreatmentLocation-streetNumberName',
     approvedSpecialistServiceTreatmentLocationSuburb: 'approvedSpecialistServiceTreatmentLocation-suburb',
     approvedSpecialistServiceTreatmentLocationState: 'approvedSpecialistServiceTreatmentLocation-state',
     approvedSpecialistServiceTreatmentLocationPostCode: 'approvedSpecialistServiceTreatmentLocation-postCode',
     transportDetailsTypeOfPublicTravel: 'transportDetailsTypeOfPublicTravel',
     specialistType: 'specialistType',
     noApplicantBankDetails: 'noApplicantBankDetails'
   },
   vptasSpecialistListForm: {
    specialistsGridFilter: 'specialistsGridFilter'
   },
   vptasLgaListForm: {
    lgaListFilter: 'vptasLgaListGridFilter'
   }
};

export const FILTER_QUESTION_CODES = {
  userListForm: {
    nameFilter: 'nameFilter',
    emailFilter: 'emailFilter',
    phoneFilter: 'phoneFilter',
    organisationFilter: 'organisationFilter',
    userTypeFilter: 'userTypeFilter'
  },
  careAllowanceApplicationListForm: {
    applicationQuickSearchTerm: 'applicationQuickSearchTerm',
    applicationReferenceNumberFilter: 'applicationReferenceNumberFilter',
    applicationTypeFilter: 'applicationTypeFilter',
    applicationStatusFilter: 'applicationStatusFilter',
    applicationAssignedToFilter: 'applicationAssignedToFilter',
    applicationSubmittedOnFromFilter: 'applicationSubmittedOnFromFilter',
    applicationSubmittedOnToFilter: 'applicationSubmittedOnToFilter',
    onHoldReasonFilter: 'onHoldReasonFilter',
    carerFirstNameFilter: 'carerFirstNameFilter',
    carerLastNameFilter: 'carerLastNameFilter',
    crisClientIDFilter: 'crisClientIDFilter',
    crisspClientIDFilter: 'crisspClientIDFilter',
    clientFirstNameFilter: 'clientFirstNameFilter',
    clientLastNameFilter: 'clientLastNameFilter',
    applicationSourceFilter: 'applicationSourceFilter'
  },
  concessionsApplicationListForm: {
    applicationQuickSearchTerm: 'applicationQuickSearchTerm',
    applicationReferenceNumberFilter: 'applicationReferenceNumberFilter',
    applicationTypeFilter: 'applicationTypeFilter',
    applicationStatusFilter: 'applicationStatusFilter',
    applicationAssignedToFilter: 'applicationAssignedToFilter',
    applicationSubmittedOnFromFilter: 'applicationSubmittedOnFromFilter',
    applicationSubmittedOnToFilter: 'applicationSubmittedOnToFilter',
    applicationYearFilter: 'applicationYearFilter',
    residentialAddressFilter: 'residentialAddressFilter',
    paidAmountFilter: 'paidAmountFilter',
    datePaidFilter: 'datePaidFilter',
    applicationSourceFilter: 'applicationSourceFilter',
    applicationFlaggedForReviewFilter: 'applicationFlaggedForReviewFilter',
    applicationBulkUploadIdFilter: 'applicationBulkUploadIdFilter',
    applicationPendingReasonFilter: 'applicationPendingReasonFilter'
  },
  careAllowancePlacementListForm: {
    placementIdFilter: 'placementIdFilter',
    iccmsPlacementIdFilter: 'iccmsPlacementIdFilter',
    oracleVendorIdFilter: 'oracleVendorIdFilter',
    clientReferenceNumberFilter: 'clientReferenceNumberFilter',
    clientNameFilter: 'clientNameFilter',
    carerReferenceNumberFilter: 'carerReferenceNumberFilter',
    carerNameFilter: 'carerNameFilter',
    invoiceNumberFilter: 'invoiceNumberFilter',
    invoiceDateFromFilter: 'invoiceDateFromFilter',
    invoiceDateToFilter: 'invoiceDateToFilter',
    paymentNumberFilter: 'paymentNumberFilter',
    paymentDateFromFilter: 'paymentDateFromFilter',
    paymentDateToFilter: 'paymentDateToFilter'
  },
  concessionsApplicationRebateCalculationRuleListForm: {
    programYearFilter: 'programYearFilter',
    paymentRuleStatusFilter: 'paymentRuleStatusFilter',
    applicationTypeFilter: 'applicationTypeFilter',
    calculationTypeFilter: 'calculationTypeFilter',
    paymentRuleTierFilter: 'paymentRuleTierFilter',
    minThresholdAmountFilter: 'minThresholdAmountFilter',
    maxThresholdAmountFilter: 'maxThresholdAmountFilter',
    paymentAmountFilter: 'paymentAmountFilter',
    percentageAmountFilter: 'percentageAmountFilter',
  },
  careAllowancePlacementRuleListForm: {
    placementTypeFilter: 'placementTypeFilter',
    placementComponentStatusFilter: 'placementComponentStatusFilter',
    placementLevelFilter: 'placementLevelFilter',
    placementComponentFilter: 'placementComponentFilter',
    firstSixMonthsEligibleFilter: 'firstSixMonthsEligibleFilter',
    schoolAllowanceEligibleFilter: 'schoolAllowanceEligibleFilter',
    targetedCareEligibleFilter: 'targetedCareEligibleFilter',
    inactiveDateBeforeFilter: 'inactiveDateBeforeFilter',
    inactiveDateAfterFilter: 'inactiveDateAfterFilter'
  },
  careAllowanceRateListForm: {
    financialYearFilter: 'financialYearFilter',
    rateStatusFilter: 'rateStatusFilter',
    rateTypeFilter: 'rateTypeFilter',
    placementTypeFilter: 'placementTypeFilter',
    placementLevelFilter: 'placementLevelFilter',
    ageMinFilter: 'ageMinFilter',
    ageMaxFilter: 'ageMaxFilter'
  },
  careAllowancePlacementInvoiceListForm: {
    oracleVendorNumberFilter: 'oracleVendorNumberFilter',
    carerContactIdFilter: 'carerContactIdFilter',
    carerFirstNameFilter: 'carerFirstNameFilter',
    carerSurnameFilter: 'carerSurnameFilter',
    carerDobFilter: 'carerDobFilter',
    invoiceNumberFilter: 'invoiceNumberFilter',
    invoiceDateFromFilter: 'invoiceDateFromFilter',
    invoiceDateToFilter: 'invoiceDateToFilter',
    paymentNumberFilter: 'paymentNumberFilter',
    paymentDateFromFilter: 'paymentDateFromFilter',
    paymentDateToFilter: 'paymentDateToFilter'
  },
  vptasInvoiceListForm: {
    oracleVendorNumberFilter: 'oracleVendorNumberFilter',
    patientContactIdFilter: 'patientContactIdFilter',
    patientFirstNameFilter: 'patientFirstNameFilter',
    patientSurnameFilter: 'patientSurnameFilter',
    patientDobFilter: 'patientDobFilter',
    invoiceNumberFilter: 'invoiceNumberFilter',
    invoiceDescriptionFilter: 'invoiceDescriptionFilter',
    invoiceDateFromFilter: 'invoiceDateFromFilter',
    invoiceDateToFilter: 'invoiceDateToFilter',
    paymentNumberFilter: 'paymentNumberFilter',
    paymentDateFromFilter: 'paymentDateFromFilter',
    paymentDateToFilter: 'paymentDateToFilter'
  },
  personListForm: {
    personRoleFilter: 'personRoleFilter',
    personEppCustomerIdFilter: 'personEppCustomerIdFilter',
    personFirstNameFilter: 'personFirstNameFilter',
    personLastNameFilter: 'personLastNameFilter',
    personGenderFilter: 'personGenderFilter',
    personDateOfBirthFilter: 'personDateOfBirthFilter',
    personEmailFilter: 'personEmailFilter',
    personPhoneFilter: 'personPhoneFilter',
    personResidentialAddressFilter: 'personResidentialAddressFilter',
    personResidentialAddressPostcodeFilter: 'personResidentialAddressPostcodeFilter',
    personResidentialAddressCityFilter: 'personResidentialAddressCityFilter',
    personResidentialAddressStateFilter: 'personResidentialAddressStateFilter',
    personResidentialAddressCountryFilter: 'personResidentialAddressCountryFilter',
    personPostalAddressFilter: 'personPostalAddressFilter',
    personPostalAddressCityFilter: 'personPostalAddressCityFilter',
    personPostalAddressStateFilter: 'personPostalAddressStateFilter',
    personPostalAddressPostcodeFilter: 'personPostalAddressPostcodeFilter',
    personPostalAddressCountryFilter: 'personPostalAddressCountryFilter',
    personCrisIdFilter: 'personCrisIdFilter',
    personCrisspIdFilter: 'personCrisspIdFilter',
    vendorNameFilter: 'vendorNameFilter',
    vendorNumberFilter: 'vendorNumberFilter',
    vendorSiteAddressFilter: 'vendorSiteAddressFilter'
  },
  vendorListForm: {
    eppVendorIdFilter: 'eppVendorIdFilter',
    oracleVendorIdFilter: 'oracleVendorIdFilter',
    vendorNameFilter: 'vendorNameFilter'
  },
  jobRunLogListForm: {
    jobTypeFilter: 'jobTypeFilter',
    jobOperationTypeFilter: 'jobOperationTypeFilter',
    jobStatusFilter: 'jobStatusFilter',
    jobRunDateAfterFilter: 'jobRunDateAfterFilter',
    jobRunDateBeforeFilter: 'jobRunDateBeforeFilter'
  },
  errorLogListForm: {
    logTypeFilter: 'logTypeFilter',
    createdTimeFilter: 'createdTimeFilter'
  },
  monitorInvoiceExportListForm: {
    batchId: 'batchId',
    batchName: 'batchName',
    batchRunFromDate: 'batchRunFromDate',
    batchRunToDate: 'batchRunToDate',
    source: 'source',
    invoiceReference: 'invoiceReference',
    invoiceStatus: 'invoiceStatus',
    invoiceDateFrom: 'invoiceDateFrom',
    invoiceDateTo: 'invoiceDateTo',
    oracleVendorId: 'oracleVendorId',
    vendorName: 'vendorName',
  },
  ConcessionsInvoiceListForm: {
    applicationIdFilter: 'applicationIdFilter',
    invoiceNumberFilter: 'invoiceNumberFilter',
    invoiceFromDateFilter: 'invoiceFromDateFilter',
    invoiceToDateFilter: 'invoiceToDateFilter',
    paymentNumberFilter: 'paymentNumberFilter',
    paymentFromDateFilter: 'paymentFromDateFilter',
    paymentToDateFilter: 'paymentToDateFilter'
  },
  concessionsApplicationBulkUploadErrorLogListForm: {
    fileNameFilter: 'fileNameFilter',
    createdTimeFilter: 'createdTimeFilter'
  },
  concessionsApplicationBulkUploadListForm: {
    agencyFilter: 'agencyFilter',
    yearFilter: 'yearFilter',
    typeFilter: 'typeFilter',
    uploadDateTimeFilter: 'uploadDateTimeFilter',
    uploadedByFilter: 'uploadedByFilter',
    fileStatusFilter: 'fileStatusFilter'
  },
  careAllowancePlacementBulkAdHocInvoiceQueryList: {
    description: 'description'
  },
  victorianPatientTransportAssistanceSchemeApplicationRebateCalculationRateListForm: {
    rateTypeFilter: 'rateTypeFilter',
    categoryFilter: 'categoryFilter',
    effectiveStartDateFilter: 'effectiveStartDateFilter',
    effectiveEndDateFilter: 'effectiveEndDateFilter',
    minThresholdAmountFilter: 'minThresholdAmountFilter',
    maxThresholdAmountFilter: 'maxThresholdAmountFilter',
    statusFilter: 'statusFilter'
  },
  victorianPatientTransportAssistanceSchemeApplicationListForm: {
    applicationQuickSearchTerm: 'applicationQuickSearchTerm',
    applicationReferenceNumberFilter: 'applicationReferenceNumberFilter',
    firstNameFilter: 'firstNameFilter',
    assignedToUserFilter: 'assignedToUserFilter',
    lastNameFilter: 'lastNameFilter',
    mobilePhoneFilter: 'mobilePhoneFilter',
    applicationStatusFilter: 'applicationStatusFilter',
    applicationSubmittedOnFromFilter: 'applicationSubmittedOnFromFilter',
    applicationSubmittedOnToFilter: 'applicationSubmittedOnToFilter',
    applicationYearFilter: 'applicationYearFilter',
    applicationTypeFilter: 'applicationTypeFilter',
    datePaidFilter: 'datePaidFilter',
    applicationSourceFilter: 'applicationSourceFilter',
    applicationFlaggedForReviewFilter: 'applicationFlaggedForReviewFilter',    
    applicationPlaceholder: 'applicationPlaceholder',
    applicationPendingReasonFilter: 'applicationPendingReasonFilter'
  },
  vptasSpecialistListForm: {
    firstNameFilter: 'firstNameFilter',
    middleNameFilter: 'middleNameFilter',
    lastNameFilter: 'lastNameFilter',
    providerNumberFilter: 'providerNumberFilter',
    suburbFilter: 'suburbFilter',
    specialtiesFilter: 'specialtiesFilter',
    stateFilter: 'stateFilter'
  },
  vptasLgaListForm: {
    localityFilter: 'localityFilter',
    postcodeFilter: 'postcodeFilter',
    lgaFilter: 'lgaFilter',
    regionFilter: 'regionFilter'
  },  
}

export const OPTION_SETS = {
  yesNo: {
    options: {
      yes: 'yes',
      no: 'no'
    }
  },
 concessionsCardType: {
    options: {
      pensionerConcessionCard: 'pensionerConcessionCard',
      healthCareCard: 'healthCareCard',
      veteransAffairsGoldCard: 'veteransAffairsGoldCard'
    }
  },
  pensionerCardIssuer: {
    options: {
      veteransAffairs: 'veteransAffairs',
      centrelink: 'centrelink'
    }
  },
  concessionsDocType: {
    options: {
      statutorydeclaration: 'statutorydeclaration',
      invoice: 'invoice'
    }
  },
  concessionConsentType: {
    options: {
      agree: 'agree',
      notagree: 'notagree',
      signed: 'signed',
      notSignedLetterProvided: 'notSignedLetterProvided',
      notSignedNoConfirmation: 'notSignedNoConfirmation',
    }
  },
  postalAddressSameOrDifferent: {
    options: {
      addNewPostalAddress: 'addNewPostalAddress',
      sameAsAbove: 'sameAsAbove'
    }
  },
  transactionType: {
    code: 'transactionType'
  },
  personRole: {
    code: 'personRole',
    options: {
      careAllowanceClient: 'careAllowanceClient',
      careAllowanceCarer: 'careAllowanceCarer',
      concessionApplicant: 'concessionApplicant',
      vptasApplicant: 'vptasApplicant',
      vptas: 'vptas'
    }
  },
  transportType: {
    options: {
      cartravel: '74dae454-afb7-4658-9436-57a90f10a22c',
      publictransport: 'CBFB175B-EC82-454B-BAC1-4F0C45B2E03C',
      privateCar: 'B2F8A1C6-3D7E-4925-A158-F7B3C8D9E2A4',
      rentalCar: 'D5A7F3B8-4C2E-4951-A674-1B5C9F8E3A26',
      communityTransport: 'F2B6E9C4-7D5A-4183-A842-6F1B8C3E9D52',
      taxiRideShare: 'C9E4B7A2-5F1D-4836-B2C5-8E9F2A6B4D17',
      ferry: 'D9F2C5E8-3B4A-4652-A974-8B6F4C2A7E95',
      interPublicStatetransport: 'B62E143E-A2FD-4649-803B-C004A05AFA0C',
      ptvVLine: 'a7f4c2b8-8e1d-4596-b273-9c5f6a2b8e41',
      commercialBus: 'c4e8b6d2-5a7f-4829-b617-7a1c5e8b9f23',
      skybus: 'b8d5a3f1-9c2e-4174-a385-2e6b9f4c7a84'
    }
  },
  claimTypes: {
    options: {
      Accommodation: '657A53A7-EAB3-46A0-B89B-9F5C85F83C13',
      Transport: 'C50D713B-CC76-4E08-B423-542F316DA8DA',
      Both: '505774B1-867B-46F4-AE28-49F5F6F8F693'
    }
  },
  transportMode: {
    options: {
      cartravel: '74dae454-afb7-4658-9436-57a90f10a22c',
      publictransport: 'CBFB175B-EC82-454B-BAC1-4F0C45B2E03C',
      commercialAirTravel: 'e8c1b4f7-6a3d-4267-b958-4e7a2c5f8b39',
    }
  },
  vptasaccommodationpaytooptionscategory: {
    options: {
      paytoSelfCode: 'PaytoSelf',
      paytoproviderCode: 'paytoprovider',
    }
  },

  typeOfTravel: {
    options: {
      privateCar: 'B2F8A1C6-3D7E-4925-A158-F7B3C8D9E2A4',
      communityTransport: 'F2B6E9C4-7D5A-4183-A842-6F1B8C3E9D52'
    }
  },
  payTo: {
    options: {
      PayToProvider: "c0123456-7890-abcd-ef12-34567890abd0",
      PayToSelf: "b0123456-7890-abcd-ef12-34567890abcf"
    }
  }
}

export const REFERENCE_DATA_IDS = {
  applicationType: {
    createCarer: '66977587-8059-454e-a8cd-4e6549ff4bf0',
    updateCarer: '05812d58-5ace-4e46-be1a-1109b4d88d2c',
    createPlacement: '4cf9b0f4-c1bb-4a77-9d54-636b591987cc',
    updatePlacement: '8490e18f-50ce-4c7e-b132-4c59af8b2746',
    updatePlacementStartEndDate: '1b6c3cc5-f73b-4908-b29f-8cc64c6dcd1a',
    updatePlacementOneOffPayment: '874ddb42-ca16-4b17-a3e2-c18d199d5485',
    updatePlacementTransfer: '811f00a9-a1a6-44e9-8150-953e1f3d5ef5',
    updatePlacementTargetedCarePackage: '775cd729-fb74-4516-9b93-2a8dba400b40',
    updatePlacementCopStatusChange: 'df90085d-10f7-412c-b413-06b2c5b4a676',
    updatePlacementCareAllowanceLevel: 'fe418b86-c7f1-43d6-b147-6c3370a3252f',
    updatePlacementClientDetails: 'cf396d9e-e08a-420f-94e5-7e703020b98d',
    updatePlacementRespiteContinueToPay: 'dcb74f41-bb5d-42a5-93af-39a3c5b746ba',
    updatePlacementMultipleElements: '9ed8bb33-8dd5-4c63-92e5-b4514db870e3',
    updatePlacementCancelPlacement: 'bd70a5dc-d21e-4ce9-8d2b-9c0642e07a72',
    updatePlacementRecallPlacement: '19324cf2-0c96-4cc2-9a7b-9d2aa6a4a2a4',
    nonMainsWater: '1bfed5c8-d9e5-4b3b-8c8a-966d656d6413',
    nonMainsEnergy: '5b78bec5-363f-410f-8810-e283b20b7e0b',
    nonMainsMedicalCooling: 'd09be042-4927-461f-9411-18676043dfb2',
    nonMainsLifeSupport: '7246a9aa-c6cd-4a04-a874-7a84e0dd0307',
    edapowGoldCardMunicipalRates: 'bd10aab8-7a15-4fea-96f4-1fdaaea66a9d',
    victorianPatientTransportAssistanceScheme: 'b9d2d2b1-8997-4402-a7ca-29eecd51bb6a',
  },
  vptasApplicationStatus: {
    ineligible: '23bbf54c-cd70-4fdc-8977-786aef74f833'
  },
  applicationStatusReason: {
    rejectedByCahd: '6a597493-03fb-4f98-aa94-2fad2a687fa3'
  },
  glStringSegmentValueType: {
    segment: '1814d831-8d6d-4dd9-acfb-da861949a403',
    lookup: '7489d718-9b54-4acf-be61-6ec3d12c017d'
  },
  careAllowanceRateStatus: {
    approved: 'ceb28264-64e0-4d81-8e48-0be869947e52',
    pendingNew: '769e7caf-cc35-4545-bbe8-f75cc7e7ac55',
    pendingUpdate: 'b9e4a340-ac93-4728-9b5a-654ec26e60c9',
    pendingDelete: 'f668ee37-b262-404b-8771-46d3c0ca4f9e'
  },
  careAllowanceRateType: {
    base: 'e554b085-76ae-4e43-bf50-4cc07173f468',
    firstSixMonths: '9982c026-7444-400b-b48a-74ae910f12ab'
  },
  concessionsApplicationRebateCalculationRuleStatus: {
    pendingNew: '1063df7c-cc6b-4346-bbdb-4ffa2eb9aae1',
    pendingUpdate: '5c35fd52-3412-48f4-b451-8ec2b51a3104',
    approved: '34658e9b-b845-405b-ac7f-bbd872de19a0'
  },
  invoiceStatus: {
    new: '539d60b8-4536-4210-8aa5-dd3bd1e4537b',
    inProgress: '1496f731-6452-4689-88fa-c607bb8e1e54',
    processed: '8057f9fa-718b-4150-8c08-4d2eb8136911',
    rejected: 'f6ea58be-c4dc-4318-9991-be28a5a70716',
    cancelled: '8e66351b-221c-4202-9234-58bf473e7246'
  },
  jobType: {
    generateCareAllowanceEducationInvoices: '34eaf165-3c90-404d-811a-77c79a1d2d65',
    careAllowancePlacementClientAgeRangeMaintenance: 'b63083ef-12dd-4f82-8dd8-7281f69d4f88',
    careAllowancePlacementFinancialYearRateChangeMaintenance: 'fb8090cb-02aa-454b-ae27-6d82a58041d7'
  },
  jobScheduleType: {
    oneOff: '3ff5a36e-6ccc-4692-93c2-02c7f5c396e2',
    recurring: 'f6593630-3a55-4e1c-a50a-450e3a6d24f0'
  },
  jobFrequencyType: {
    weekly: '8889f1be-f2f1-4adf-a7af-167d3aa17ed3'
  },
  careAllowanceUserRole:
  {
    careAllowanceCarer: '14bebe78-27db-4e77-9714-6f3239b3a842',
    careAllowanceClient: 'b11caae9-2cf3-4953-942f-28ee01d8c042',

  },
  victorianPatientTransportAssistanceSchemeRebateRateStatus: {
    pendingNew: '59f6e697-9004-4758-a3f3-182da68a69de',
    pendingUpdate: 'c0d1ec99-bd88-44ff-ac5e-1b5f85344f87',
    approved: '65253c18-7730-4677-b798-a7d7e3ac93cf'
  },
}

export const APPLICATION_STATUS_CODES = {
  draft: 'draft',
  new: 'new',
  inprogress: 'inprogress',
  accepted: 'accepted',
  submitted: 'submitted',
  rejected: 'rejected',
  completed: 'completed',
  onhold: 'onhold',
  ineligible: 'ineligible'
}

export const FORM_IDENTIFIERS = {
  concessionsFormIdentifier: '8bcb561d-f685-42e1-87ca-7c31a32b4728',
  concessionsBulkUploadFormIdentifier: 'be4d4ca4-8134-4470-8803-b11e77f5be87',
  vptsFormIdentifier: '72B8E2FA-1C4D-5E6F-7890-A1B2C3D4E5F6'
}

export const SAVE_RESULT_STATUS = {
  success: 'Success',
  invalidAction: 'InvalidAction',
  invalidActionCode: 7
}

export const CARD_TYPE_ID = {
  DepartmentOfVeteransAffairs: 1,
  Centrelink: 2
}
export const MISCELLANEOUS_TRANSACTION_TYPE_CODES = {
  overPayment: 'd0001',
  immediatePayment: 'i0001',
  debitAdjustment: 'kdr01',
  creditAdjustment: 'kcr01'
}

export const SETTINGS = {
  careAllowanceNegotiatedCreditAdjustmentAmountLimit: 'CareAllowanceNegotiatedCreditAdjustmentAmountLimit',
  careAllowanceImmediatePaymentAdjustmentAmountLimit: 'CareAllowanceImmediatePaymentAdjustmentAmountLimit',
  careAllowanceNegotiatedDebitAdjustmentAmountLimit: 'CareAllowanceNegotiatedDebitAdjustmentAmountLimit',
  careAllowanceOverPaymentRecoveryAdjustmentAmountLimit: 'CareAllowanceOverPaymentRecoveryAdjustmentAmountLimit'
}


export class UIDateTimeFormat {
  static readonly date = 'dd/MM/yyyy';
  static readonly dateTime = 'dd/MM/yyyy HH:mm';
  static readonly locale = 'en-AU';
  static readonly UIDateStringFormForPeriod = 'd MMMM yyyy'
}

export class NominationFields {
  static readonly consent = 'consent';
  static readonly cardType = 'cardType';
  static readonly cardFullName = 'cardFullName';
  static readonly centrelinkCard = 'centrelinkCard';
  static readonly veteransAffairsCardNumber = 'veteransAffairsCardNumber';
  static readonly gender = 'gender';
  static readonly aboriginalOrTorresStraitIslanderDescent = 'aboriginalOrTorresStraitIslanderDescent';
}
export const ClaimTypes = {
  Accommodation: '657A53A7-EAB3-46A0-B89B-9F5C85F83C13',
  Transport: 'C50D713B-CC76-4E08-B423-542F316DA8DA',
  Both: '505774B1-867B-46F4-AE28-49F5F6F8F693'
}
export const VptasCommonConstants = {
     consentText:'agree',
     veteranCardTypeText:'veteransAffairsCard',
     accommodationDetailsCheckInDate:'accommodationDetailsCheckInDate'
}

export const VPTAS_AGE_CATEGORIES = {
  infant: 'infant',
  child: 'child',
  adult: 'adult'
}

export const VPTAS_AGE_THRESHOLDS = {
  infantDays: 180,     // 6 months = 180 days
  adultDays: 6570      // 18 years = 6570 days (18 * 365)
}

export const VPTAS_CLAIM_FOR_IDS = {
  patientOnly: '1f2a3b4c-5d6e-7f80-9123-4567890abcde',
  escortOnly: '2a3b4c5d-6e7f-8091-2345-67890abcdef1',
  patientAndEscort: '3b4c5d6e-7f80-9123-4567-890abcdef123',
  patientAndTwoEscorts: '4c5d6e7f-8091-2345-6789-0abcdef12345',
  twoEscorts: '5d6e7f80-9123-4567-890a-bcdef1234567'
}

export const VPTAS_TRIP_TYPE_IDS = {
  single: '27C24B5B-DA8A-46B9-B37F-847A1EA3AD09',
  dropOff: 'c3d4e5f6-789a-bcde-f012-3456789abcde',
  pickUp: 'd4e5f678-9abc-def0-1234-56789abcdef0',
  return: '2bbcbee2-833e-42dd-8ab7-3ba3d11a4a15'
}

export const AGE_THRESHOLDS = {
  vptasConcessionCardMinimumAge: 18
}
// This is used to open a dialog from the callback of another dialog being closed.
// Unfortunately there is no reliable way to wait for the dialog to close.
export const MinWaitForDialogToCloseMs = 200;
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
